import HttpClient from './httpClient';

export const api = new HttpClient({
  baseURL: '/api',
});
